import { useNavigate } from "react-router-dom";
import { Button } from "../components/Button";
import { LinkGen } from "../LinkGen";
import { Empty, EmptyPage } from "../layout/EmptyLayout";

export const PageNotFound = () => {
	const navigate = useNavigate();

	return (
		<EmptyPage title="Page not found">
			<Empty.Container>
				<Empty className="text-center">
					<Empty.Header>404</Empty.Header>
					<Empty.Title>The page you requested was not found.</Empty.Title>
					<Button full onClick={() => navigate(LinkGen.Dashboard())}>
						Home
					</Button>
				</Empty>
			</Empty.Container>
		</EmptyPage>
	);
};
